import React from "react";
import { Twemoji } from "react-emoji-render";

import { Grid, Typography } from "@material-ui/core";
import { Card, Loader } from "../../_common";

import useStyles from "./styles";
import { useCampaigns } from "../../../hooks";

const Campaigns = () => {
  const { campaignsRoot, messageContainer, message } = useStyles();
  const [{ campaigns, total_reg, loadingCampaigns }] = useCampaigns();

  if (loadingCampaigns) {
    return <Loader />;
  }

  return (
    <Grid container className={campaignsRoot}>
      {total_reg !== 0 ? (
        campaigns.map(campaign => <Card key={campaign.id} data={campaign} />)
      ) : (
        <Grid container className={messageContainer}>
          <Typography className={message}>
            <Twemoji svg text="😧" /> Parece que no hay campañas activas. ¡Te
            esperamos más tarde!
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default Campaigns;
